import {
  MutationOptions,
  QueryObserverOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

import {
  getUserColumnPreferences,
  getUserProfile,
  putUserProfile,
  uploadUserColumnPreferences,
} from 'api/user';
import {
  GetUserProfileResponseDTO,
  UpdateUserRequestBodyDTO,
  UploadUserColumnPreferences,
} from 'declarations/dto/user';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

type UseUpdateUserParamsT = {
  onSuccess: MutationOptions<void, ApiErrorI, UpdateUserRequestBodyDTO>['onSuccess'];
};

type UseFetchUserPreferencesParamsT = {
  onSuccess: QueryObserverOptions<string, ApiErrorI>['onSuccess'];
  onError: QueryObserverOptions<string, ApiErrorI>['onError'];
};

export const useFetchUser = (idToken: string | null) =>
  useQuery<GetUserProfileResponseDTO, ApiErrorI>([RequestQueryKeysE.FetchUser], getUserProfile, {
    enabled: !!idToken,
    staleTime: RequestStaleTimeE.UserProfile,
  });

export const useUpdateUser = ({ onSuccess }: UseUpdateUserParamsT) =>
  useMutation<void, ApiErrorI, UpdateUserRequestBodyDTO>(
    [RequestQueryKeysE.UpdateUser],
    userProfileData => putUserProfile(userProfileData),
    { onSuccess }
  );

export const useFetchUserColumnPreferences = ({ onSuccess }: UseFetchUserPreferencesParamsT) => {
  return useQuery<string, ApiErrorI>(
    [RequestQueryKeysE.FetchUserColumnPreferences],
    getUserColumnPreferences,
    { onSuccess, enabled: !localStorage.getItem('visibleColumns') }
  );
};

export const useUpdateUserColumnPreferences = () =>
  useMutation<void, ApiErrorI, UploadUserColumnPreferences>(
    [RequestQueryKeysE.UpdateUserColumnPreferences],
    userColumnPreferencesData => uploadUserColumnPreferences(userColumnPreferencesData)
  );
